import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import {
  AuditTrailDetailModal,
  FieldChangeModal,
} from 'src/modules/features/admin/modals';
import { Location } from '@angular/common';
import { CompanyService } from '../../../services';
import { Subject } from 'rxjs';
import { map, take, takeUntil, tap } from 'rxjs/operators';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';

import {
  NewTccRecordModal,
  EditTccRecordModal,
} from 'src/modules/features/contractor/modals';
import { OtherTccRecordModal } from '../../../modals/other-tcc-record-modal/other-tcc-record-modal.component';
import { EditCompanyDetailModal } from '../../../modals/edit-company-detail-modal/edit-company-detail-modal.component';

@Component({
  selector: 'app-company-record',
  templateUrl: './company-record.component.html',
  styleUrls: ['./company-record.component.scss'],
})
export class CompanyRecordComponent implements OnInit {
  companyTcc = [];
  otherCompanyTcc = [];
  isBusinessName: boolean = false;
  projectId: string;
  success: any;
  unsubscribe$: Subject<boolean> = new Subject();
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;

  successTwo: any;
  errorTwo: any;
  pendingTwo: boolean;
  filterTwo: AppFilter = new AppFilter();
  totalItemsTwo: number = 5;
  rowsTwo: number = 2;
  currentPageTwo: number = 1;
  maxSizeTwo: number = 7;
  documentStatus;

  organizationId: string;
  message;
  redirect_url;
  applicationType;
  companyType;
  // searchFilter = {
  //   groupOp: 'AND',
  //   rules: [
  //     {
  //       field: 'taxPayerName',
  //       op: 'cn',
  //       data: '',
  //     },
  //     {
  //       field: 'taxOffice',
  //       op: 'cn',
  //       data: '',
  //     },
  //     //   {
  //     //     field: 'tccIssueDate',
  //     //     op: 'cn',
  //     //     data: '',
  //     //   },
  //   ],
  // };
  pendingHistory;
  pendingStrcuture;
  pendingDocuments;
  pendingArray;
  allHistory;
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private companySvc: CompanyService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.message = window.localStorage.getItem('message');
    this.applicationType = window.localStorage.getItem('application_type');
    this.redirect_url = window.localStorage.getItem('redirect_url');
    this.organizationId = window.localStorage.getItem('organizationId');

    this.companyType = JSON.parse(
      window.localStorage.getItem('organization')
    )?.jpaContractor.companyType.optionId;
    this.getCompanyType();

    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10 });
    this.getPage(1);
    this.getOtherTccData(1);
    this.getHistory(1);

    this.activatedRoute.parent.params.subscribe((params) => {
      this.projectId = params['id'];
    });
  }

  getCompanyType() {
    // let companyType = this.organization?.jpaContractor?.companyType?.optionId;
    if (
      this.companyType === 'business_name_actual' ||
      this.companyType === 'business_name'
    ) {
      this.isBusinessName = true;
    }
  }

  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.companySvc
      .getCompanyTcc({
        organizationId: this.organizationId,
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.companyTcc = res['rows'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getHistory(page) {
    this.companySvc
      .getRequestHistory({
        organizationId: this.organizationId,
        changeRequestType: 'OTHER_TCC',
        params: this.filter,
      })
      .pipe(
        tap((res) => {
          this.totalItems = +res['records'];
          this.currentPage = page;
          this.rows = this.filter.rows;
        })
      )
      .subscribe(
        (res: any) => {
          this.allHistory = res['rows'];
          this.allHistory.forEach((row) => {
            if (row.fromValue) {
              row.fromValue = JSON.parse(row.fromValue);
            }
            if (row.toValue) {
              row.toValue = JSON.parse(row.toValue);
            }
          });
          this.pendingArray = res['rows'].filter(
            (item) => item.status === 'PENDING'
          );
          this.pendingArray.forEach((row) => {
            if (row.fromValue) {
              row.fromValue = JSON.parse(row.fromValue);
            }
            if (row.toValue) {
              row.toValue = JSON.parse(row.toValue);
            }
          });

          this.pending = false;
        },
        (error) => {
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
          this.pending = false;
        }
      );
  }
  getTOtalItems() {}
  getOtherTccData(page) {
    this.filterTwo.page = page;

    // this.filter.filters = JSON.stringify(this.searchFilter);
    this.pendingTwo = true;
    this.companySvc
      .getOtherTccRecords({
        organizationId: this.organizationId,
        params: this.filterTwo,
      })
      .subscribe(
        (res: any) => {
          this.pendingTwo = false;
          this.totalItemsTwo = +res.records;
          this.rowsTwo = this.filterTwo.rows;
          this.otherCompanyTcc = res['rows'];
        },
        (error) => {
          this.pendingTwo = false;
          this.errorTwo = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  detailCompany(event) {}
  deactivateCompany(event) {}
  serviceAccess(event) {}
  chatCompany(event) {}
  verifyCompany(event) {}
  addDocument() {}
  deleteMulti() {}
  addCompany() {}
  viewCompany(event) {
    this.modalService
      .open(
        new AuditTrailDetailModal(
          'Row Data',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove((payload) => {
        // this.addWorkflowGroup(payload);
      })
      .onDeny(() => {});
  }

  newRecord(val) {
    this.modalService
      .open(
        new NewTccRecordModal(
          'Add New TCC ID',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Mini
        )
      )

      // editDetail(val) {
      // this.modalService
      // .open(new EditCompanyDetailModal('Add New TCC ID', val))
      // .onApprove((company: any) => {
      // this.organization = { ...this.organization, ...company };
      // this.getVerificationStatus();
      // });
      .onApprove(() => {
        this.getPage(1);
      })
      .onDeny(() => {});
    // }
  }

  otherTCCRecord() {
    this.modalService
      .open(
        new OtherTccRecordModal(
          'Add Other Tax Clearance ID',
          'Are you sure you want to delete this Lot plan?',
          false,
          ModalSize.Mini
        )
      )
      .onApprove(() => {
        this.getOtherTccData(1);
        this.getHistory(1);
        setTimeout(() => {
          this.router.navigateByUrl(
            '/contractor/company/record?documentStatus=pending'
          );
        }, 1000);
      })
      .onDeny(() => {});
  }

  viewChangeField(event) {
    this.modalService
      .open(
        new FieldChangeModal(
          'Changed Field',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove((payload) => {
        // this.addWorkflowGroup(payload);
      })
      .onDeny(() => {});
  }

  onDelete() {}

  delete(app) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Workflow?',
          'Are you sure you want to delete this workflow?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
  goBack() {
    this.location.back();
  }

  searchRecords(search) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'taxPayerName',
          op: 'cn',
          data: '',
        },
        {
          field: 'taxOffice',
          op: 'cn',
          data: '',
        },
        // {
        // 	field: 'tccIssueDate',
        // 	op: 'cn',
        // 	data: ''
        // }
      ],
    };
    searchFilter.rules[0].data = search;
    searchFilter.rules[1].data = search;
    // searchFilter.rules[2].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  searchRecordsTwo(search) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'taxPayerName',
          op: 'cn',
          data: '',
        },
        {
          field: 'taxOffice',
          op: 'cn',
          data: '',
        },
        // {
        // 	field: 'tccIssueDate',
        // 	op: 'cn',
        // 	data: ''
        // }
      ],
    };
    searchFilter.rules[0].data = search;
    searchFilter.rules[1].data = search;
    // searchFilter.rules[2].data = search;
    this.filterTwo.filters = JSON.stringify(searchFilter);
    this.getOtherTccData(1);
  }
  //handle sorting records
  sortRecordsTwo(search) {
    this.filterTwo.sord = search;
    this.getOtherTccData(1);
  }

  //handles rows display
  displayRecordsTwo(row) {
    this.filterTwo['rows'] = row;
    this.getOtherTccData(1);
  }

  nextPageTwo(page: number) {
    //get and assign current page
    this.currentPageTwo = page;
    this.getOtherTccData(this.currentPageTwo);
  }

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
      if (
        event instanceof NavigationStart &&
        event.url != `/contractor/company/record`
      ) {
        localStorage.removeItem('message');
        localStorage.removeItem('application_type');
        localStorage.removeItem('redirect_url');
      }
    });
    this.route.queryParams.subscribe((res) => {
      if (res['documentStatus']) {
        this.documentStatus = res['documentStatus'];
      } else {
        this.documentStatus = 'verified';
        this.router.navigate(['/contractor/company/record'], {
          queryParams: { documentStatus: 'verified' },
        });
      }
      // this.getPage(1);
    });
  }
}
